import { motion } from 'framer-motion';

const Intro = () => {
  return (
    <section className="py-24 md:py-32 px-6">
      <div className="max-w-5xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-xs tracking-[0.2em] uppercase font-bold text-accent mb-6"
        >
          Sobre nós
        </motion.p>
        
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-4xl md:text-5xl font-light tracking-tight text-primary mb-8"
        >
          Onde a Natureza Encontra o Conforto
        </motion.h2>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-lg md:text-xl leading-relaxed text-muted-foreground mb-6"
        >
          Em meio à Mata Atlântica, as Cabanas Meio do Mato oferecem uma experiência única de
          hospedagem. Nossos espaços foram projetados para conectar você com a natureza, sem
          abrir mão do conforto e sofisticação.
        </motion.p>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="text-base leading-relaxed text-foreground/80"
        >
          Cabanas com teto e paredes de vidro, piscinas privativas aquecidas, cinema ao ar livre
          e automação completa. Cada detalhe foi pensado para criar momentos inesquecíveis.
        </motion.p>
      </div>
    </section>
  );
};

export default Intro;